/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ItemDisplayPromoCodeWrapper_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItemPromoCode_item$ref: FragmentReference;
export type CartItemPromoCode_item = {|
  +serviceId: ?string,
  +$fragmentRefs: ItemDisplayPromoCodeWrapper_item$ref,
  +$refType: CartItemPromoCode_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItemPromoCode_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemDisplayPromoCodeWrapper_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5330d7e632ed23ed8ee69cc9b177dc7a';
module.exports = node;
